import { render, staticRenderFns } from "./ChangeGivenPrice.vue?vue&type=template&id=19e71f95&scoped=true"
import script from "./ChangeGivenPrice.vue?vue&type=script&lang=js"
export * from "./ChangeGivenPrice.vue?vue&type=script&lang=js"
import style0 from "./ChangeGivenPrice.vue?vue&type=style&index=0&id=19e71f95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e71f95",
  null
  
)

export default component.exports